<template>
  <div class="pt50">
    <div class="container">
      <div class="breadcrumb-wrapper">
        <router-link to="/">首页</router-link> > <span style="color: #666">违规信息反馈</span >
      </div>
      <div class="c-border help-container">
        <div>
          <el-form label-position="top" label-width="100px" >
            <el-form-item label="举报标题" required>
              <el-input v-model.trim="title"
                        maxLength='50'
                        placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="举报内容" required>
              <el-input
                      v-model="content"
                      type="textarea"
                      maxLength='200'
                      show-word-limit
                      :rows="10"
                      placeholder="请输入您要反馈的内容"
                      onkeydown="if (event.keyCode===13){return false;}"></el-input>
              <span style="position: absolute; right: 116px; bottom: 0;">{{ content ? content.length : 0 }}/200</span>
            </el-form-item>
          </el-form>
          <div style="padding-right: 0px;padding-top: 0px;padding-left: 500px;">
            <el-button type="primary" @click="change()">提 交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getToken } from '../../utils/auth';


export default {
    data(){
        return{
            title: '',
            content: ''
        }
    },

    mounted(){
        this.loginStatus();
    },

    methods: {
        loginStatus(){
            let token = getToken();
            if(!token){
                this.$router.push('/login')
                return;
            }
        },

        async change(){
            if(!this.title){
                this.$message.warning('请输入标题！');
                return;
            }
            if(!this.content){
                this.$message.warning('请输入内容！');
                return;
            }
            if(this.content.split("\n").join("").length === 0){
                this.$message.warning('内容不可全部为空！');
                return;
            }
            if(this.content.split(" ").join("").length === 0){
                this.$message.warning('内容不可全部为空！');
                return;
            }
            console.log(this.content)
            let token = getToken();
            let data = {
                token,
                title : this.title,
                content : this.content
            };
            let res = await this.$post('/api/saveProblemFeedback',data);
            if(res.code==='200'){
                this.visibility = false;
                this.$message.success(res.message)
                this.$router.push('/')
            }else{
                this.$message.warning(res.message)
            }
        }
    }

}
</script>

<style>

.help-container{
  background:#fff;
  padding: 20px 32px;
}

.pt50{
  padding-bottom: 50px;
}

span{
  color: #ffffff;
}
</style>
